var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.inDropdown)?_c('div',{staticClass:"dropdown-divider"}):_c('div',{staticClass:"action-separator-vertical"})
}
var staticRenderFns = []

export { render, staticRenderFns }